import { render } from "./responsive-image.vue?vue&type=template&id=1f7d77fd"
import script from "./responsive-image.vue?vue&type=script&lang=js"
export * from "./responsive-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__